// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"938055c9","239":"d9d04dfb","455":"ba487dcb"}[chunkId] + ".chunk.js";
};